jQuery(document).ready(function($) {
  
  // Detect desktop only (min-width 992px)
  if (window.matchMedia("(min-width: 992px)").matches) {

    let $mediaList = $('.product__media-list');

    // Prevent duplicate slider initialization
    if (!$mediaList.hasClass('slick-initialized')) {

      $mediaList.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        infinite: false,
        prevArrow:"<button type='button' class='slick-prev pull-left'><img src='https://cdn.shopify.com/s/files/1/0601/4500/8695/files/3a771debe649814de23bd73098b1835ec9477022.png?v=1752586296' alt='arrow'></button>",
    nextArrow:"<button type='button' class='slick-next pull-right'><img src='https://cdn.shopify.com/s/files/1/0601/4500/8695/files/3a771debe649814de23bd73098b1835ec9477022.png?v=1752586296' alt='arrow'></button>",  
        speed: 400,
        adaptiveHeight: true,
      });
    }
  }

});

jQuery(document).ready(function($){

  // Only run on desktop / if slick exists
  if ($('.product__media-list').hasClass('slick-initialized')) {

    $('.thumbnail').on('click', function(e){
      e.preventDefault();

      // Get the index attribute from the button
      let slideIndex = parseInt($(this).attr('index'));

      // Go to that slick slide
      $('.product__media-list').slick('slickGoTo', slideIndex);

      // Optional: add active class to selected thumbnail
      $('.thumbnail').removeClass('active-thumb');
      $(this).addClass('active-thumb');
    });

  }

});

$(document).ready(function(){
  $(".details-wellness").wrapAll("<div class='display-wellness-flex' />");
  $(".details-cooking").wrapAll("<div class='display-cooking-flex' />")
  $(".display-wellness-flex, .display-cooking-flex").wrapAll("<div class='display-oils-flex' />")
  //$("<div class='heading-oils'><div class='heading-in-fl-oils'>Wellness Use</div><div class='heading-in-fl-oils'>Cooking Use</div></div>").insertBefore(".display-oils-flex");

$(".display-wellness-flex").prepend("<div class='heading-in-fl-oils'>Wellness Use</div>");
$(".display-cooking-flex").prepend("<div class='heading-in-fl-oils'>Cooking Use</div>");
  $(".sticky-atc__btnn").on("click", function (){
        $(".product-form__submit").trigger("click");
        $(this).text("Adding...")
        setTimeout(function(){ $(".sticky-atc__btnn").text("Add To Cart") }, 1500);

    })
  $(".shopify-section.faq-section").wrapAll("<div class='faq-on-right' />");
  $(".shopify-section.faq-navigation, .faq-on-right").wrapAll("<div class='faq-on-flex' />");
    $(".title-heading div").click(function () {
      var attr = $(this).attr("href");
        $("html, body").animate({
            scrollTop: $(attr).offset().top - 100 // Adjust 100px as needed
        }, 800); // 800ms animation speed
    });
  $(".tab-item").click(function (e) {
    e.preventDefault();
    e.stopPropagation();
      var attr = $(this).attr("href");
        $("html, body").animate({
            scrollTop: $(attr).offset().top - 100 // Adjust 100px as needed
        }, 800); // 800ms animation speed
    });

  $(".build-you-jar").click(function (e) {
    e.preventDefault();
    e.stopPropagation();
      var attr = $(".wellness-jar-hero");
        $("html, body").animate({
            scrollTop: $(attr).offset().top - 100 // Adjust 100px as needed
        }, 800); // 800ms animation speed
    });
  $(".btn-nav, .open-jar-select").click(function () {
      var attr = $(".wellness-jar-hero");
        $("html, body").animate({
            scrollTop: $(attr).offset().top - 100 // Adjust 100px as needed
        }, 800); // 800ms animation speed
    });
  
  $(".heading-section").on("click", function(){
    $(this).parents(".faq-category").find(".faq-content").slideToggle();
    $(this).toggleClass("active-faq");
  })
  $('.swiper-wrapperr ul.grid.product-grid.contains-card').slick({
  dots: false,
  infinite: false,
  speed: 300,
  slidesToShow: 2,
  slidesToScroll: 1,
    arrows:true,
    prevArrow:"<button type='button' class='slick-prev pull-left'><svg width='40' height='40' viewBox='0 0 50 50' fill='none' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'><circle cx='25' cy='25' r='24' fill='white' stroke='#939B79' stroke-width='2'/><rect width='20' height='20' transform='matrix(-1 0 0 1 35 15)' fill='url(#pattern0_287_13)'/><defs><pattern id='pattern0_287_13' patternContentUnits='objectBoundingBox' width='1' height='1'><use xlink:href='#image0_287_13' transform='scale(0.00195312)'/></pattern><image id='image0_287_13' width='512' height='512' preserveAspectRatio='none' xlink:href='data:image/png;base64,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'/></defs></svg></button>",
    nextArrow:"<button type='button' class='slick-next pull-right'><svg width='40' height='40' viewBox='0 0 50 50' fill='none' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'><circle cx='25' cy='25' r='24' fill='white' stroke='#939B79' stroke-width='2'/><rect x='15' y='15' width='20' height='20' fill='url(#pattern0_287_12)'/><defs><pattern id='pattern0_287_12' patternContentUnits='objectBoundingBox' width='1' height='1'><use xlink:href='#image0_287_12' transform='scale(0.00195312)'/></pattern><image id='image0_287_12' width='512' height='512' preserveAspectRatio='none' xlink:href='data:image/png;base64,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'/></defs></svg></button>",  
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});
  $('.ingredient-carousel').slick({
  dots: false,
  infinite: false,
  speed: 300,
  slidesToShow:4,
  slidesToScroll: 1,
    arrows:true,
    prevArrow:"<button type='button' class='slick-prev pull-left'><img src='https://cdn.shopify.com/s/files/1/0601/4500/8695/files/3a771debe649814de23bd73098b1835ec9477022.png?v=1752586296' alt='arrow'></button>",
    nextArrow:"<button type='button' class='slick-next pull-right'><img src='https://cdn.shopify.com/s/files/1/0601/4500/8695/files/3a771debe649814de23bd73098b1835ec9477022.png?v=1752586296' alt='arrow'></button>",  
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2.5,
        slidesToScroll: 1,
        infinite: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1.5,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});
   $('.ig-slider-track').slick({
  dots: false,
  infinite: false,
  speed: 300,
  slidesToShow: 5,
  slidesToScroll: 1,
    arrows:true,
    prevArrow:"<button type='button' class='slick-prev pull-left'><svg width='40' height='40' viewBox='0 0 50 50' fill='none' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'><circle cx='25' cy='25' r='24' fill='white' stroke='#939B79' stroke-width='2'/><rect width='20' height='20' transform='matrix(-1 0 0 1 35 15)' fill='url(#pattern0_287_13)'/><defs><pattern id='pattern0_287_13' patternContentUnits='objectBoundingBox' width='1' height='1'><use xlink:href='#image0_287_13' transform='scale(0.00195312)'/></pattern><image id='image0_287_13' width='512' height='512' preserveAspectRatio='none' xlink:href='data:image/png;base64,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'/></defs></svg></button>",
    nextArrow:"<button type='button' class='slick-next pull-right'><svg width='40' height='40' viewBox='0 0 50 50' fill='none' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'><circle cx='25' cy='25' r='24' fill='white' stroke='#939B79' stroke-width='2'/><rect x='15' y='15' width='20' height='20' fill='url(#pattern0_287_12)'/><defs><pattern id='pattern0_287_12' patternContentUnits='objectBoundingBox' width='1' height='1'><use xlink:href='#image0_287_12' transform='scale(0.00195312)'/></pattern><image id='image0_287_12' width='512' height='512' preserveAspectRatio='none' xlink:href='data:image/png;base64,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'/></defs></svg></button>",  
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2.3,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1.3,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});
  
  
  $('.testimonial-slider').slick({
  dots: true,
  infinite: false,
  speed: 300,
  slidesToShow: 1,
  slidesToScroll: 1,
    arrows:true,
    prevArrow:"<button type='button' class='slick-prev pull-left'><svg width='40' height='40' viewBox='0 0 76 76' fill='none' xmlns='http://www.w3.org/2000/svg'><circle cx='38' cy='38' r='37' fill='white' stroke='#939B79' stroke-width='2'/><path d='M21.9393 36.9393C21.3536 37.5251 21.3536 38.4749 21.9393 39.0607L31.4853 48.6066C32.0711 49.1924 33.0208 49.1924 33.6066 48.6066C34.1924 48.0208 34.1924 47.0711 33.6066 46.4853L25.1213 38L33.6066 29.5147C34.1924 28.9289 34.1924 27.9792 33.6066 27.3934C33.0208 26.8076 32.0711 26.8076 31.4853 27.3934L21.9393 36.9393ZM53 38V36.5L23 36.5V38V39.5L53 39.5V38Z' fill='#939B79'/></svg></button>",
    nextArrow:"<button type='button' class='slick-next pull-right'><svg width='40' height='40' viewBox='0 0 76 76' fill='none' xmlns='http://www.w3.org/2000/svg'><circle cx='38' cy='38' r='37' fill='white' stroke='#939B79' stroke-width='2'/><path d='M54.0607 39.0607C54.6464 38.4749 54.6464 37.5251 54.0607 36.9393L44.5147 27.3934C43.9289 26.8076 42.9792 26.8076 42.3934 27.3934C41.8076 27.9792 41.8076 28.9289 42.3934 29.5147L50.8787 38L42.3934 46.4853C41.8076 47.0711 41.8076 48.0208 42.3934 48.6066C42.9792 49.1924 43.9289 49.1924 44.5147 48.6066L54.0607 39.0607ZM23 38V39.5H53V38V36.5H23V38Z' fill=''#939B79'/></svg></button>",  
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});
  $('.testimonial-grid').slick({
  dots: false,
  infinite: false,
  speed: 300,
  slidesToShow: 3,
  slidesToScroll: 1,
    arrows:false,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1.3,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1.3,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});

  $('.collection-list-wrapper ul.collection-list').slick({
  dots: false,
  infinite: false,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 1,
    arrows:false,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1.3,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1.3,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});
  // $(document).on("change", "input.quantity__input", function(){
  //   var get = $(this).val();
  //   console.log(get)
  //   var priceRegular = $(".price__regular span.price-item.price-item--regular").attr("price");
  //   priceRegular = priceRegular.replace("$","").replace("CAD","").trim();
  //   var finalRegular = parseFloat(priceRegular) * parseInt(get);
  //   $(".price__regular span.price-item.price-item--regular").text("$"+finalRegular);

  //   const priceSaleregular = $(".price__sale s.price-item.price-item--regular").text();
  //   //var priceSaleregular = $(".price__sale s.price-item.price-item--regular").text();
  //   var prcc = priceSaleregular.replace("$","").replace("CAD","").trim();
  //   var finalpriceSaleregular = parseFloat(prcc) * parseInt(get);
  //   $(".price__sale s.price-item.price-item--regular").text("$"+finalpriceSaleregular);

  //   const priceSale = $(".price__sale span.price-item.price-item--sale.price-item--last").text();
  //   //var priceSale = $(".price__sale span.price-item.price-item--sale.price-item--last").text();
  //   var pricec = priceSale.replace("$","").replace("CAD","").trim();
  //   var finalpriceSale = parseFloat(pricec) * parseInt(get);
  //   $(".price__sale span.price-item.price-item--sale.price-item--last").text("$"+finalpriceSale);
    
  // })

  //custom subscription page

  var fixedQty = 3;
  var totalSelected = [];
  var totalPselected = [];
  var totalPrice = [];
  $("button.plus-quantity").on("click", function(){
    totalSelected = [];
    totalPselected = [];
    totalPrice = [];
    var selectedVariant = $(this).parents(".collection-product-item").find("select").val();
    var getPrice = $(this).parents(".collection-product-item").find(".product-price").attr("price");
    var getQty = $(this).siblings("input").val(); 
    var getTotal = parseInt(getQty) + parseInt(1);
    $(this).siblings("input").val(getTotal)
    var getTotalprice = parseFloat(getPrice) * parseInt(getTotal);
    $(this).parents(".collection-product-item").attr("final-price", getTotalprice.toFixed(2))
    $(".collection-product-item").each(function(){
      totalSelected.push($(this).find(".quantity-box input").val())
    })
    let totalCount = totalSelected.length;
    // Sum of numeric values
    let totalSum = 0;
    totalSelected.forEach(function(num){totalSum+=parseFloat(num) || 0;});
    console.log(totalSum)
    if ( totalSum == 1 )
    {
      $("span.progress-bar-in").css({"width":"33.33333%"});
      //$(".f-atc-subscription").attr("disabled", "disabled");
    }
    else if ( totalSum == 2 )
    {
      $("span.progress-bar-in").css({"width":"66.6666%"});
     // $(".f-atc-subscription").attr("disabled", "disabled");
    }
    else if ( totalSum == 3 )
    {
      $("span.progress-bar-in").css({"width":"100%"});
     // $(".f-atc-subscription").removeAttr("disabled");
    }

    var pThumb = $(this).parents(".collection-product-item").find("img").attr("src");
    var pId = $(this).parents(".collection-product-item").attr("p-id");
    if ( $(".product-selected-item[sid='"+pId+"']").length > 0 )
    {
      
      $(".collection-product-item[p-id='"+pId+"']").each(function(){
        totalPselected.push($(this).find(".product-quantity-selector input").val())
      })
      console.log(totalPselected)
      var totalPSum = 0;
      totalPselected.forEach(function(num){totalPSum+=parseFloat(num) || 0;});
      console.log(totalPSum)
      $(".product-selected-item[sid='"+pId+"']").find(".count").text(totalPSum)
    }
    else
    {
      $(".product-selection-dynamic").append("<div class='product-selected-item' sid='"+pId+"' variant-id='"+selectedVariant+"'><div class='select-product-thumb'><span class='count'>"+getTotal+"</span><img src='"+pThumb+"'></div><div class='btn-remove'><button class='remove-btn'><svg xmlns='http://www.w3.org/2000/svg' fill='none' class='icon icon-close' viewBox='0 0 18 17'><path fill='currentColor' d='M.865 15.978a.5.5 0 0 0 .707.707l7.433-7.431 7.579 7.282a.501.501 0 0 0 .846-.37.5.5 0 0 0-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 1 0-.707-.708L8.991 7.853 1.413.573a.5.5 0 1 0-.693.72l7.563 7.268z'></path></svg></button></div></div>")
    }
    $(".collection-product-item").each(function(){
      totalPrice.push($(this).attr("final-price"));
    })
    let totalPricee = 0;
    totalPrice.forEach(function(num){totalPricee+=parseFloat(num) || 0;});
    console.log(totalPricee)
    $("span.sub-final-price").text("$"+totalPricee.toFixed(2))
    var freeShippingThreshold = 100;
        var currentTotal = totalPricee;
        // if (currentTotal < freeShippingThreshold) {
        //       var remaining = parseFloat(freeShippingThreshold) - parseFloat(currentTotal);
        //       var progress = (parseFloat(currentTotal) / parseFloat(freeShippingThreshold)) * 100;
        //       $('#shipping-message').text("You're $" + remaining.toFixed(2) + " away from FREE shipping!");
        //       $('#shipping-progress').css('width', progress + '%');
        //        $(".f-atc-subscription").attr("disabled", "disabled");
        //     } else {
        //       $('#shipping-message').text("🎉 Congratulations! You’ve unlocked FREE shipping!");
        //       $('#shipping-progress').css('width', '100%');
        //        $(".f-atc-subscription").removeAttr("disabled");
        //     }
  })

  $("button.minus-quantity").on("click", function(){
    totalPselected = [];
    totalPrice = [];
    var getPrice = $(this).parents(".collection-product-item").find(".product-price").attr("price");
    var getQty = $(this).siblings("input").val();
      if ( getQty > 0 )
      {
        totalSelected = [];
        var getTotal = parseInt(getQty) - parseInt(1);
        $(this).siblings("input").val(getTotal)
        var getTotalprice = parseFloat(getPrice) * parseInt(getTotal);
        $(this).parents(".collection-product-item").attr("final-price", getTotalprice.toFixed(2))
        $(".collection-product-item").each(function(){
          totalSelected.push($(this).find(".quantity-box input").val())
        })
        let totalCount = totalSelected.length;
        // Sum of numeric values
        let totalSum = 0;
        totalSelected.forEach(function(num){totalSum+=parseFloat(num) || 0;});
        console.log(totalSum)
        // if ( totalSum == 0 )
        // {
        //   $("span.progress-bar-in").css({"width":"0%"});
        //   $(".f-atc-subscription").attr("disabled", "disabled");
        // }
        //   else if ( totalSum == 1 )
        // {
        //   $("span.progress-bar-in").css({"width":"33.33333%"});
        //   $(".f-atc-subscription").attr("disabled", "disabled");
        // }
        // else if ( totalSum == 2 )
        // {
        //   $("span.progress-bar-in").css({"width":"66.66666%"});
        //   $(".f-atc-subscription").attr("disabled", "disabled");
        // }
        // else if ( totalSum == 3 )
        // {
        //   $("span.progress-bar-in").css({"width":"100%"});
        //   $(".f-atc-subscription").removeAttr("disabled");
        // }

        var pThumb = $(this).parents(".collection-product-item").find("img").attr("src");
    var pId = $(this).parents(".collection-product-item").attr("p-id");
    if ( $(".product-selected-item[sid='"+pId+"']").length > 0 )
    {
      
      $(".collection-product-item[p-id='"+pId+"']").each(function(){
        totalPselected.push($(this).find(".product-quantity-selector input").val())
      })
      let totalPSum = 0;
      totalPselected.forEach(function(num){totalPSum+=parseFloat(num) || 0;});
      console.log(totalPSum)
      console.log(totalPselected)
      $(".product-selected-item[sid='"+pId+"']").find(".count").text(totalPSum)
      if ( totalPSum == 0 )
      {
        $(".product-selected-item[sid='"+pId+"']").remove();
      }
    }
    $(".collection-product-item").each(function(){
      totalPrice.push($(this).attr("final-price"));
    })
    let totalPricee = 0;
    totalPrice.forEach(function(num){totalPricee+=parseFloat(num) || 0;});
    console.log(totalPricee)
    $("span.sub-final-price").text("$"+totalPricee.toFixed(2))
        var freeShippingThreshold = 100;
        var currentTotal = totalPricee;
        // if (currentTotal < freeShippingThreshold) {
        //       var remaining = parseFloat(freeShippingThreshold) - parseFloat(currentTotal);
        //       var progress = (parseFloat(currentTotal) / parseFloat(freeShippingThreshold)) * 100;
        //       $('#shipping-message').text("You're $" + remaining.toFixed(2) + " away from FREE shipping!");
        //       $('#shipping-progress').css('width', progress + '%');
        //        $(".f-atc-subscription").attr("disabled", "disabled");
        //     } else {
        //       $('#shipping-message').text("🎉 Congratulations! You’ve unlocked FREE shipping!");
        //       $('#shipping-progress').css('width', '100%');
        //        $(".f-atc-subscription").removeAttr("disabled");
        //     }
        
      }

    
    
  })

  //selector dynamic
  $("select.dynamic-p-selector").on("change", function(){
    var price = $(this).find("option:selected").attr("variant-price");
    var pid = $(this).parents(".collection-product-item").attr("pid");
    $(".product-selected-item[sid='"+pid+"']").attr("variant-id", $(this).find("option:selected").val())
    $(this).parents(".collection-product-item ").find(".product-price").text(price)
    $(this).parents(".collection-product-item ").find(".product-price").attr("price", $(this).find("option:selected").attr("variant-price-wt-money"));
  })

  // $.ajax({
  //   type:"POST",
  //   url: "/cart/add.js",
  //   async:false,
    
  // })
  var itemTocart = [];
  // $("button.f-atc-subscription").on("click", function(){
  //   itemTocart = [];
  //   $(".product-selected-item").each(function(){
  //     itemTocart.push($(this).attr("variant-id")+"/"+$(this).find("span.count").text());
      
  //   })
  //   console.log(itemTocart)
  //   for ( var i=0; i < itemTocart.length; i++ )
  //   {
  //     console.log(itemTocart[i])
  //     var myArray = itemTocart[i].split("/");
  //     $.ajax({
  //       type:"POST",
  //       url:"/cart/add.js",
  //       data: {
  //         quantity: parseInt(myArray[1]),
  //         id: parseInt(myArray[0])
  //       },
  //       async:false,
  //       dataType:"json",
  //       success: function (data) {
  //         console.log("added to Cart")
  //       }
  //     })
  //   }
  //   window.location = "/cart";
  // })
  //var itemTocart = [];

$("button.f-atc-subscription").on("click", function () {
  itemTocart = [];
var selectedopt = $(".selling-plan-selector").find("input:checked").val();
  console.log(selectedopt)
  $(".product-selected-item").each(function () {
    let variantId = $(this).attr("variant-id");
    let quantity = $(this).find("span.count").text();
    let sellingPlan = $("option[value='"+variantId+"']").parents("select").parents(".product-dynamic-options").find("input[data-plan-name='"+selectedopt+"']").val() || ""; // get selling_plan if present
    console.log(sellingPlan)
    itemTocart.push({
      id: parseInt(variantId),
      quantity: parseInt(quantity),
      selling_plan: sellingPlan !== "" ? sellingPlan : null
    });
  });

  console.log(itemTocart);

  let ajaxCalls = itemTocart.map((item, index) => {
    let postData = {
      id: item.id,
      quantity: item.quantity
    };

    if (item.selling_plan) {
      postData.selling_plan = item.selling_plan;
    }

    return $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: postData,
      dataType: "json",
      async: false, // Note: consider using async true and chaining instead
      success: function (data) {
        console.log("Added to cart:", data);
      },
      error: function (err) {
        console.error("Error adding to cart:", err);
      }
    });
  });

  // Redirect to cart after all AJAX requests complete
  $.when.apply($, ajaxCalls).done(function () {
     window.location = "/cart";
  });
});

  $(document).on("click", "button.remove-btn", function(){
    totalPrice = [];
    totalSelected = [];
    var getId = $(this).parents(".product-selected-item").attr("sid");
    console.log(getId)
    $(".collection-product-item[p-id='"+getId+"']").find("input").val("0")
    var getPrice = $(".collection-product-item[p-id='"+getId+"']").find(".product-price").attr("price");
    var finalPrice = parseInt(getPrice) * 0;
    $(".collection-product-item[p-id='"+getId+"']").attr("final-price", finalPrice)
    $(".collection-product-item").each(function(){
      totalPrice.push($(this).attr("final-price"));
    })
    let totalPricee = 0;
    totalPrice.forEach(function(num){totalPricee+=parseFloat(num) || 0;});
    console.log(totalPricee)
    $("span.sub-final-price").text("$"+totalPricee.toFixed(2))

    var freeShippingThreshold = 100;
        var currentTotal = totalPricee;
        // if (currentTotal < freeShippingThreshold) {
        //       var remaining = parseFloat(freeShippingThreshold) - parseFloat(currentTotal);
        //       var progress = (parseFloat(currentTotal) / parseFloat(freeShippingThreshold)) * 100;
        //       $('#shipping-message').text("You're $" + remaining.toFixed(2) + " away from FREE shipping!");
        //       $('#shipping-progress').css('width', progress + '%');
        //        $(".f-atc-subscription").attr("disabled", "disabled");
        //     } else {
        //        $(".f-atc-subscription").removeAttr("disabled");
        //       $('#shipping-message').text("🎉 Congratulations! You’ve unlocked FREE shipping!");
        //       $('#shipping-progress').css('width', '100%');
        //     }

    $(".collection-product-item").each(function(){
          totalSelected.push($(this).find(".quantity-box input").val())
        })
        let totalCount = totalSelected.length;
        // Sum of numeric values
        let totalSum = 0;
        totalSelected.forEach(function(num){totalSum+=parseFloat(num) || 0;});
        console.log(totalSum)
        // if ( totalSum == 0 )
        // {
        //   $("span.progress-bar-in").css({"width":"0%"});
        //   $(".f-atc-subscription").attr("disabled", "disabled");
        // }
        //   else if ( totalSum == 1 )
        // {
        //   $("span.progress-bar-in").css({"width":"33.33333%"});
        //   $(".f-atc-subscription").attr("disabled", "disabled");
        // }
        // else if ( totalSum == 2 )
        // {
        //   $("span.progress-bar-in").css({"width":"66.66666%"});
        //   $(".f-atc-subscription").attr("disabled", "disabled");
        // }
        // else if ( totalSum == 3 )
        // {
        //   $("span.progress-bar-in").css({"width":"100%"});
        //   $(".f-atc-subscription").removeAttr("disabled");
        // }
    $(this).parents(".product-selected-item").remove()
  })

  $(".go-btn").click(function () {
      var attr = $(this).attr("id");
        $("html, body").animate({
            scrollTop: $("."+attr).offset().top - 100 // Adjust 100px as needed
        }, 800); // 800ms animation speed
    });

  $(".open-jar-select").on("click", function(){
    $(".step1").hide();
    $(".step2").show();
  })
  $("button.btn-prev.btn-nav").on("click", function(){
    var get = $(this).attr("goto");
    $("."+get).show();
    $(this).parents(".build-steps").hide();
  });
  var $bottleSize = '';
  $(".btn-nav").on("click", function(){
    if ( $(this).parents(".build-steps.step2 ").find(".bottle-options input:checked").length > 0 )
    {
    var get = $(this).attr("goto");
    $("."+get).show();
    $(this).parents(".build-steps").hide();
      $bottleSize = $(this).parents(".build-steps.step2 ").find(".bottle-options input:checked").val();
    }
    if ( $(".build-steps.step3 .bottle .oil-layer").length >= 2 )
    {
    var get = $(this).attr("goto");
    $("."+get).show();
    $(this).parents(".build-steps").hide();
    $(".error").text("")
    }
    else
    {
      $(".error").text("Pick more than one oil to create your blend!")
    }
  })

  

  $(".build-options.bottle-sizes .bottle-options input").on("change", function(){
    var getimg = $(this).attr("option-image");
    $(".build-image").attr("image-size",$(this).val())
    $(".build-image img").attr("src", getimg)
  })
  $(".save-your-jar input").on("input", function (){
    if ( $(this).val().length < 15 )
    {
      $(".blend-name").text($(this).val())
    }
    
    
  })
  $(".subsc-opt").on("click", function(){
    $(this).addClass("active");
    $(this).prevAll(".subsc-opt").removeClass("active");
    $(this).nextAll(".subsc-opt").removeClass("active");
  })
  var fprice = [];
  $(".upsell-enable").on("change", function(){
    fprice = [];
    
    if ($(this).val() == "Yes")
    {
      var getItprice = $(this).find("input").attr("price");
      $("select.custom-quantities").each(function(){
        fprice.push($(this).attr("finalprice"));
      })
      var totalJarPrice = 0;
        var labourCharge = 5;
        fprice.forEach(function(num){totalJarPrice+=parseFloat(num) || 0;});
        
        console.log(totalJarPrice)
        var finalOut = parseFloat(totalJarPrice) + parseInt(labourCharge)  + parseFloat(getItprice);
        console.log(finalOut)
        $("span.price-here-total").text("$"+finalOut.toFixed(2))
        $(".price-hide").val(finalOut.toFixed(2))
    }
    else
    {
      $("select.custom-quantities").each(function(){
        fprice.push($(this).attr("finalprice"));
      })
        var totalJarPrice = 0;
        var labourCharge = 0;
        
        fprice.forEach(function(num){totalJarPrice+=parseFloat(num) || 0;});
        
        console.log(totalJarPrice)
        if ( totalJarPrice > 0 )
        {
          labourCharge = 5;
        }
        else
        {
          labourCharge = 0;
        }
        var finalOut = parseFloat(totalJarPrice) + parseInt(labourCharge) ;
        console.log(finalOut)
        $("span.price-here-total").text("$"+finalOut.toFixed(2))
        $(".price-hide").val(finalOut.toFixed(2))
    }
    $(this).toggleClass("active");
    
  })
  var ids = [];
  $("button.final-checkout-btn").on("click", function(){
    ids = [];
    var getSize = $(".build-steps.step2").find("input:checked").val();
    console.log(getSize);
    $(".build-steps.step3").find("button.oil-btn.active").each(function (){
      var getVid = $(this).find("select.dynamic-p-selector-jar").find("option[v-title='"+getSize+"']").val();
      ids.push(getVid);
    })
  console.log(ids);
  })

      
      const $inputs = $('.custom-quantities');
      const $bottle = $('.bottle');
      const $totalQty = $('#totalQty');
      const $bottleCapacity = $('#bottleCapacity');
      const $errorMsg = $('#errorMsg');

      function updateBottle() {
        const maxCapacity = parseInt($(".build-steps.step2").find("input:checked").val());
        $bottleCapacity.text(maxCapacity);

        let total = 0;
        let oils = [];
        let valid = true;

        $inputs.each(function () {
          const qty = parseInt($(this).val()) || 0;
          const name = $(this).data('name');
          const color = $(this).data('color');

          if (qty > 0) {
            if (qty < 100 || qty > 900 || qty % 50 !== 0) {
              $errorMsg.text(`${name}: Quantity must be between 100ml and 900ml in steps of 50ml.`);
              $bottle.empty();
              $(".build-steps.step3 button.btn-next.btn-nav").attr("disabled", "disabled");
              valid = false;
              return false;
            }
            

            oils.push({ qty, name, color });
            total += qty;
          }
        });

        if (!valid) return;

        $totalQty.text(total);
        
        if (total > maxCapacity) {
          $errorMsg.text("You’ve exceeded the bottle capacity!");
          $bottle.empty();
          $(".build-steps.step3 button.btn-next.btn-nav").attr("disabled", "disabled");
          return;
        } else {
          $errorMsg.text("");
          $(".build-steps.step3 button.btn-next.btn-nav").removeAttr("disabled");
        }

        $bottle.empty();
        let currentBottom = 0;

        oils.forEach((oil, index) => {
          const height = (oil.qty / maxCapacity) * 100;
          const layer = $('<div class="oil-layer"> </div>').css({
            backgroundColor: oil.color,
            height: `${height}%`,
            bottom: `${currentBottom}%`
          });

          const label = $('<div class="oil-label"> </div>')
            .text(oil.name)
            .addClass(index % 2 === 0 ? 'left' : 'right')
            .css({
              bottom: `${currentBottom + (height / 2) - 4}%`
            });

          $bottle.append(layer);
          $bottle.append(label);
          currentBottom += height;
        });
      }
      
      $(".build-steps.step2").find("input").on('change', updateBottle);
      $inputs.on('input', updateBottle);
      updateBottle(); // Init on load
      var jarPrice = [];
      $(".custom-quantities").on("change", function(){
        jarPrice = []
        var price1ml = $(this).attr("price-1ml");
        var finalPrice = parseFloat(price1ml) * parseFloat($(this).val())
        $(this).attr("finalprice", finalPrice)
        $(".selection-item").each(function(){
          jarPrice.push($(this).find(".custom-quantities").attr("finalprice"));
        })
        console.log(jarPrice)
        var totalJarPrice = 0;
        var labourCharge = 0;
        jarPrice.forEach(function(num){totalJarPrice+=parseFloat(num) || 0;});
        
        console.log(totalJarPrice)
        if ( totalJarPrice > 0 )
        {
          labourCharge = 5;
        }
        else
        {
          labourCharge = 0;
        }
        var finalOut = parseFloat(totalJarPrice) + parseInt(labourCharge)
        console.log(finalOut)
        if ( $("input#upsell").is(":checked") )
        {
          var getHprice = $("input#upsell").attr("price");
          finalOut =  parseFloat(totalJarPrice) + parseFloat(getHprice) +  parseInt(labourCharge)
        }
        $("span.price-here-total").text("$"+finalOut.toFixed(2))
        $(".price-hide").val(finalOut.toFixed(2))

        $("select.custom-quantities").find("option").each( function(){
            var getCapacity = $("#bottleCapacity").text();
            var filledBottle = $('#totalQty').text();
            var spaceLeft = parseInt(getCapacity) - parseInt(filledBottle);
            
          if ($(this).val() > spaceLeft)
          {
            console.log($(this).val() +" -- "+ spaceLeft)
            // $(this).attr("disabled", "disabled");
            $(this).addClass("disabled");
          }
          else
          {
            // $(this).removeAttr("disabled");
            $(this).removeClass("disabled");
          }
          });
      })
      $(".build-steps.step2 button.btn-next.btn-nav").on("click", function (){
          $("select.custom-quantities").find("option").each( function(){
            var getCapacity = $("#bottleCapacity").text();
            var filledBottle = $('#totalQty').text();
            var spaceLeft = parseInt(getCapacity) - parseInt(filledBottle);
            
          if ($(this).val() > spaceLeft)
          {
            console.log($(this).val() +" -- "+ spaceLeft)
            // $(this).attr("disabled", "disabled");
            $(this).addClass("disabled");
          }
          else
          {
            // $(this).removeAttr("disabled");
            $(this).removeClass("disabled");
          }
          });
      })
      
  //build another jar
  $(".build-steps.step4 button.btn-next.build-another-jar").on("click", function (e){
   e.preventDefault();
    $(".loader1").show()
    $(this).css({"font-size":"0px"})
  var  thiss = $(this);  
  var get = $(this).attr("goto");
    

 const formData = $("#build-your-jar").serializeArray();
  const customJarData = {};
  formData.forEach(field => {
    customJarData[field.name] = field.value;
  });


async function createAndAddToCart() {
  const res = await fetch("https://adsagenz.com/create-custom-jar.php", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      jar_name: $(".save-your-jar").find("input").val(),
      price: $("input.price-hide").val()
    })
  });

  const data = await res.json();

  if (data.success && data.variant_id) {
    
    // Build properties object
    const properties = {
      "Jar Name": data.properties["Jar Name"],
      "Bottle Size": $(".build-steps.step2 input:checked").val()+"ml"
    };

    // Loop through oil inputs (make sure they have class 'oil-input' and data-name)
    $("select.custom-quantities").each(function () {
      const name = $(this).data("name");
      const value = parseFloat($(this).val());
      if (value > 0) {
        properties[name] = `${value}ml`;
      }
    });

    if ( $("input#upsell").is(":checked") )
        {
          var name = 'Upsell';
          var getHprice = $("input#upsell").attr("price");
          var getHtitle = $("input#upsell").attr("p-title");
          properties[name] = `${getHtitle} + ${getHprice}`;
        }

    // Add to cart
    // const addToCart = await fetch("/cart/add.js", {
    //   method: "POST",
    //   headers: { "Content-Type": "application/json" },
    //   body: JSON.stringify({
    //     id: data.variant_id,
    //     quantity: 1,
    //     properties: properties
    //   })
    // });

    let attempts = 0;
const maxAttempts = 10;

const intervalId = setInterval(async () => {
  attempts++;

  try {
    const addToCart = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        id: data.variant_id,
        quantity: 1,
        properties: properties
      })
    });

    const cartResponse = await addToCart.json();

    if (addToCart.ok) {
      clearInterval(intervalId);
      console.log("✅ Added to cart:", cartResponse);
      window.location.href = "/cart";
      return;
    }

    console.warn(`❌ Attempt ${attempts} failed`, cartResponse);

    // stop after max attempts
    if (attempts >= maxAttempts) {
      clearInterval(intervalId);
      console.error("❌ /cart/add.js failed after retries:");
      console.error("Status:", addToCart.status, addToCart.statusText);
      console.error("Error details:", cartResponse);
    }

  } catch (err) {
    console.error(`❌ Attempt ${attempts} exception:`, err);

    if (attempts >= maxAttempts) {
      clearInterval(intervalId);
      console.error("❌ Stopped retrying after exceptions.");
    }
  }
}, 1000); // 1000ms = 1 second

    const cartResponse = await addToCart.json();
    console.log("✅ Added to cart:", cartResponse);

    // Optionally redirect to cart
     //window.location.href = "/cart";
      $("."+get).show();
      thiss.parents(".build-steps").hide();
      $("span.price-here-total").text("$00")
      $("form#build-your-jar")[0].reset()
      $("input#upsell").prop("checked", true);
      $(".bottle-options input").prop("checked", false);
      $("select.custom-quantities").val("0").trigger("change");
      $("select.custom-quantities").find("option").removeClass("disabled");
      $(".save-your-jar").find("input").val();
      $("select.custom-quantities").removeAttr("finalprice");
      $(".build-steps.step4 button.btn-next.build-another-jar").css({"font-size":"18px"});
      $(".loader1").hide();
    
    $("input.price-hide").val("")
  } else {
    alert("Something Went Wrong! Try again later.")
    console.error("❌ Product creation failed:", data.error);
  }
}
// Then call the function when needed:
createAndAddToCart();

  // $.ajax({
  //   url: 'https://adsagenz.com/mahaanss/create-custom-jar.php',
  //   method: 'POST',
  //   data: customJarData,
  //   success: function(response) {
  //     const data = JSON.parse(response);
  //     if (data.success) {
  //       // Add to cart using variant ID + properties
  //       $.post('/cart/add.js', {
  //         id: data.variant_id,
  //         quantity: 1,
  //         properties: data.properties
  //       }, function() {
  //         window.location.href = '/cart'; // Optional
  //       });
  //     } else {
  //       alert('Failed to create jar: ' + data.error);
  //     }
  //   }
  // });

  })
  //checkout press
  $(".build-steps.step4 button.btn-next.btn-nav").on("click", function (e){
   e.preventDefault();
  var get = $(this).attr("goto");
    $("."+get).show();
    $(this).parents(".build-steps").hide();

 const formData = $("#build-your-jar").serializeArray();
  const customJarData = {};
  formData.forEach(field => {
    customJarData[field.name] = field.value;
  });


async function createAndAddToCart() {
  const res = await fetch("https://adsagenz.com/create-custom-jar.php", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      jar_name: $(".save-your-jar").find("input").val(),
      price: $("input.price-hide").val()
    })
  });

  const data = await res.json();
  console.log(data);
  if (data.success && data.variant_id) {
    
    // Build properties object
    const properties = {
      "Jar Name": data.properties["Jar Name"],
      "Bottle Size": $(".build-steps.step2 input:checked").val() + "ml"
    };

    // Loop through oil inputs
    $("select.custom-quantities").each(function () {
      const name = $(this).data("name");
      const value = parseFloat($(this).val());
      if (value > 0) {
        properties[name] = `${value}ml`;
      }
    });

    if ($("input#upsell").is(":checked")) {
      var name = 'Upsell';
      var getHprice = $("input#upsell").attr("price");
      var getHtitle = $("input#upsell").attr("p-title");
      properties[name] = `${getHtitle} + ${getHprice}`;
    }

    // Add to cart
    let attempts = 0;
const maxAttempts = 10;

const intervalId = setInterval(async () => {
  attempts++;

  try {
    const addToCart = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        id: data.variant_id,
        quantity: 1,
        properties: properties
      })
    });

    const cartResponse = await addToCart.json();

    if (addToCart.ok) {
      clearInterval(intervalId);
      console.log("✅ Added to cart:", cartResponse);
      window.location.href = "/cart";
      return;
    }

    console.warn(`❌ Attempt ${attempts} failed`, cartResponse);

    // stop after max attempts
    if (attempts >= maxAttempts) {
      clearInterval(intervalId);
      console.error("❌ /cart/add.js failed after retries:");
      console.error("Status:", addToCart.status, addToCart.statusText);
      console.error("Error details:", cartResponse);
    }

  } catch (err) {
    console.error(`❌ Attempt ${attempts} exception:`, err);

    if (attempts >= maxAttempts) {
      clearInterval(intervalId);
      console.error("❌ Stopped retrying after exceptions.");
    }
  }
}, 1000); // 1000ms = 1 second

  } else {
    console.error("❌ Product creation failed:", data.error);
  }
}
// Then call the function when needed:
createAndAddToCart();

  // $.ajax({
  //   url: 'https://adsagenz.com/mahaanss/create-custom-jar.php',
  //   method: 'POST',
  //   data: customJarData,
  //   success: function(response) {
  //     const data = JSON.parse(response);
  //     if (data.success) {
  //       // Add to cart using variant ID + properties
  //       $.post('/cart/add.js', {
  //         id: data.variant_id,
  //         quantity: 1,
  //         properties: data.properties
  //       }, function() {
  //         window.location.href = '/cart'; // Optional
  //       });
  //     } else {
  //       alert('Failed to create jar: ' + data.error);
  //     }
  //   }
  // });

  })

  $('.plus-btn').click(function () {
  const $input = $(this).siblings('.oil-input')[0]; // Get the DOM element, not jQuery object

  if ($input.stepUp) {
    $input.stepUp(); // Native increment
    $input.dispatchEvent(new Event('input', { bubbles: true }));
    $input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  updateBottle(); // Your custom function
});

$('.minus-btn').click(function () {
  const $input = $(this).siblings('.oil-input')[0]; // Get the DOM element

  if ($input.stepDown) {
    $input.stepDown(); // Native decrement
    $input.dispatchEvent(new Event('input', { bubbles: true }));
    $input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  updateBottle(); // Your custom function
});


// $(".slider-for-image-block").slick({
//   dots: true,
//   arrows:false,
//   infinite: false,
//   speed: 300,
//   infinite:true,
//   slidesToShow: 1,
//   slidesToScroll: 1,
//     arrows:false,
//     prevArrow:"<button type='button' class='slick-prev pull-left'><img src='https://cdn.shopify.com/s/files/1/0601/4500/8695/files/3a771debe649814de23bd73098b1835ec9477022.png?v=1752586296' alt='arrow'></button>",
//     nextArrow:"<button type='button' class='slick-next pull-right'><img src='https://cdn.shopify.com/s/files/1/0601/4500/8695/files/3a771debe649814de23bd73098b1835ec9477022.png?v=1752586296' alt='arrow'></button>",  
//   responsive: [
//     {
//       breakpoint: 1024,
//       settings: {
//         slidesToShow: 1,
//         slidesToScroll: 1,
//         infinite: true
//       }
//     },
//     {
//       breakpoint: 600,
//       settings: {
//         slidesToShow: 1,
//         slidesToScroll: 1
//       }
//     },
//     {
//       breakpoint: 480,
//       settings: {
//         slidesToShow: 1,
//         slidesToScroll: 1
//       }
//     }
//     // You can unslick at a given breakpoint now by adding:
//     // settings: "unslick"
//     // instead of a settings object
//   ]
// });

$(".slick-slider-feat-collection").slick({
  dots: false,
  infinite: false,
  speed: 300,
  infinite:true,
  slidesToShow: 4,
  slidesToScroll: 1,
    arrows:true,
    prevArrow:"<button type='button' class='slick-prev pull-left'><img src='https://cdn.shopify.com/s/files/1/0601/4500/8695/files/3a771debe649814de23bd73098b1835ec9477022.png?v=1752586296' alt='arrow'></button>",
    nextArrow:"<button type='button' class='slick-next pull-right'><img src='https://cdn.shopify.com/s/files/1/0601/4500/8695/files/3a771debe649814de23bd73098b1835ec9477022.png?v=1752586296' alt='arrow'></button>",  
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});
  $('.blend-swiper-mobile-wrapper').slick({
  dots: false,
  infinite: false,
  speed: 300,
  centerMode: true,
  mobileFirst: true,
  infinite:true,
  centerPadding: '60px',
  slidesToShow: 1,
  slidesToScroll: 1,
    arrows:true,
    prevArrow:"<button type='button' class='slick-prev pull-left'><img src='https://cdn.shopify.com/s/files/1/0601/4500/8695/files/3a771debe649814de23bd73098b1835ec9477022.png?v=1752586296' alt='arrow'></button>",
    nextArrow:"<button type='button' class='slick-next pull-right'><img src='https://cdn.shopify.com/s/files/1/0601/4500/8695/files/3a771debe649814de23bd73098b1835ec9477022.png?v=1752586296' alt='arrow'></button>",  
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1.2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});
})

const details = document.querySelectorAll('.mega-menu');

details.forEach(menu => {
  menu.addEventListener('mouseenter', () => {
    menu.setAttribute('open', true);
  });

  menu.addEventListener('mouseleave', () => {
    menu.removeAttribute('open');
  });
});



$(document).ready(function () {
  $(document).on("change", ".sr-only.js-option", function(){
    var getPrice = $(this).attr("var-price")
    $(this).parents(".custom-atc-btn").find("span.card-sale-price").text(getPrice)
    var getId = $(this).attr("val-id");
    $(this).parents().find(".js-variant-id").val(getId)
  })
      $(document).on("click", "button.move-atc-dynamic.show-above-fold", function(){
        $(this).siblings(".custom-product-options").slideToggle()
        // $(this).hide();
      })
      $(document).on("click", "button.close-over-popup",  function(){
        $(this).parents(".custom-product-options").slideToggle()
        // $(this).parents("form ").find("button.move-atc-dynamic.show-above-fold").show();
      })

      $(".subscription-widget label input").on("change", function(){
    if ($(this).is(":checked"))
    {
      $(this).siblings("span.checkbox-custom").addClass("active-check");
      
    }
    else
    {
      $(this).siblings("span.checkbox-custom").removeClass("active-check");
    }
  })
  $(document).on("click", ".subscription-widget-cart label ",  function(e){
    e.preventDefault();
    e.stopPropagation();
    $(this).find("span.checkbox-custom").toggleClass("active-check");
    if ($(this).find("span.checkbox-custom").hasClass("active-check"))
    {
      
      $("#subscription-frequency-cart").show();
    }
    else
    {
      //$(this).siblings("span.checkbox-custom").removeClass("active-check");
      $("#subscription-frequency-cart").hide();
    }
  })
  $(".product-form__quantity, .shopify-add-to-cart").wrapAll("<div class='quantity-and-atc' />");
    });



    const radius = 16;
const circumference = 2 * Math.PI * radius;
const autoplaySpeed = 3000; // must match slick autoplaySpeed

function animateDot($circle) {
  // reset
  $circle
    .css({ transition: 'none', strokeDashoffset: circumference })
    .get(0).getBoundingClientRect(); // force reflow

  // animate
  $circle.css({
    transition: `stroke-dashoffset ${autoplaySpeed}ms linear`,
    strokeDashoffset: 0
  });
}


    jQuery(function ($) {
  const $slider = $('.slider-for-image-block');

  $slider.on('init', function () {
    // set up dasharray for all dots
    $('.slick-dots .progress-ring').css({
      strokeDasharray: circumference,
      strokeDashoffset: circumference
    });

    // let browser paint, then animate first dot
    setTimeout(function () {
      const $first = $('.slick-dots li').eq(0).find('.progress-ring');
      animateDot($first);
    }, 50);
  });

  $slider.slick({
    dots: true,
    arrows: false,
    autoplay: true,
    autoplaySpeed: autoplaySpeed,
    pauseOnHover: false,
    pauseOnFocus: false,
    customPaging: function () {
      return `
        <svg viewBox="0 0 36 36">
          <circle class="progress-bg" cx="18" cy="18" r="16" stroke-width="4" fill="none"/>
          <circle class="progress-ring" cx="18" cy="18" r="16" stroke-width="4" fill="none"/>
        </svg>
      `;
    }
  });

  // before changing slide → reset all rings
  $slider.on('beforeChange', function () {
    $('.slick-dots .progress-ring').css({
      transition: 'none',
      strokeDashoffset: circumference
    });
  });

  // after change → animate active one
  $slider.on('afterChange', function (e, slick, current) {
    const $active = $('.slick-dots li').eq(current).find('.progress-ring');
    animateDot($active);
  });
});